export const ControlTimelineTab = {
  ACTIVITY: 'activity',
  OVERVIEW: 'overview',
} as const
